<template>
    <div>
        <div class="help-block">{{$t("Sisesta onnitluse sisu")}}</div>
        <div class="row">
            <div class="col-md-6" ref="dataContainer">
                <div class="form-group">
                    <label for="name">
                        {{$t('Onnitletava nimi')}}
                        <span class="fas fa-info-circle" v-b-popover.hover.bottom="$t('popover onnitlus nimi')"></span>
                    </label>
                    <input :maxlength="200" @change="saveState" class="form-control" id="name" v-model="name">
                </div>
                <div class="form-group">
                    <label class="w-100" for="beginningText">{{$t('Alguse tekst')}}
                        <span class="fas fa-info-circle"
                              v-b-popover.hover.bottom="$t('popover onnitlus algusetekst')"></span>
                        <span class="float-right charcount">{{(200 - beginningText.length)}}</span>
                    </label>
                    <textarea :maxlength="200" @change="saveState" class="form-control" id="beginningText"
                              rows="9" v-model="beginningText">
                    </textarea>
                </div>

                <div class="form-group">
                    <label class="w-100" for="endingText">{{$t('Lopu tekst')}}
                        <span class="fas fa-info-circle" v-b-popover.hover.bottom="$t('popover onnitlus loputekst')">
                        </span>
                        <span class="float-right charcount">{{(200 - endingText.length)}}</span>
                    </label>

                    <textarea :maxlength="200" @change="saveState" class="form-control" id="endingText"
                              rows="9" v-model="endingText">
                    </textarea>
                </div>

                <div class="form-group custom-control custom-checkbox vertical-margin">
                    <input @change="saveState" class="custom-control-input" id="has-poem" type="checkbox"
                           v-model="hasPoem">
                    <label class="custom-control-label w-100" for="has-poem">{{$t('Luuletus')}}
                        <span class="fas fa-info-circle"
                              v-b-popover.hover.bottom="$t('popover onnitlus luuletus')"></span>
                        <span class="float-right charcount" v-if="customPoem">{{(500 - customPoem.length)}}</span>
                    </label>
                </div>
                <div v-if="hasPoem">
                    <textarea :maxlength="500" @change="saveState" class="form-control mb-2"
                              id="customPoem" rows="9" v-model="customPoem">
                    </textarea>
                    <v-select :options="poems[$i18n.locale]" :placeholder="$t('Vali olemasolev luuletus')"
                              :searchable="false" @input="saveState"
                              v-model="poem">
                        <template v-slot:option="option">
                            <span v-html="option.text"></span>
                        </template>
                    </v-select>
                </div>

                <div class="form-group custom-control custom-checkbox vertical-margin">
                    <input @change="saveState" @click="symbolChanged()" class="custom-control-input" id="has-symbol"
                           type="checkbox"
                           v-model="imageOrSymbol" value="symbol">
                    <label class="custom-control-label w-100" for="has-symbol">
                        {{$t('Pilt voi sumbol')}}
                        <span class="fas fa-info-circle"
                          v-b-popover.hover.bottom="$t('popover onnitlus pilt symbol')"></span>
                    </label>
                    
                </div>
                <div class="form-group custom-control custom-checkbox z-0" v-if="imageOrSymbol">
                    <div class="row">
                        <div class="col-2 m-0 p-1" v-for="s in symbols">
                            <img :src="s.data" @click="pickSymbol(s)" class="w-100 border"
                                 v-bind:class="{'border-dark':symbol!=null && symbol.id === s.id}">
                        </div>
                    </div>
                </div>
                <div v-if="imageOrSymbol">
                    <div class="form-group">
                        <input 
                            ref="fileInput"
                            type="file" 
                            accept="image/*" 
                            @change="onFileChosen" 
                            class="form-control d-none" 
                        />
                        <input :value="$t('Lae pilt oma arvutist')" @click="fileInput.click()"
                               class="form-control"
                               readonly/>
                    </div>
                </div>
                <MyCropper
                    :visible="Boolean(imageOrSymbol && imageContent)"
                    :image-content="imageContent"
                    :callback="cropperCallback"
                />
            </div>
            <div :class="previewTabClasses">
                <div class='box' :class="previewClasses">
                    <div class='content preview preview-box'>
                        <div>
                            <div class="text-center poem p-1" v-if="hasPoem && !imageOrSymbol">
                                <span v-html="poem.text" v-if="poem"></span>
                                <span style="white-space: pre-line" v-else>{{customPoem}}</span>
                            </div>
                            <div class="p-3" v-if="!hasPoem && imageOrSymbol">
                                <div :height="previewSize" :width="previewSize" v-if="hasImage">
                                    <img :src="imgUrl" class="w-100">
                                </div>
                                <div class="text-center" v-if="hasSymbol && symbol!=null">
                                    <img :height="previewSize" :src="symbol.data" :width="previewSize">
                                </div>
                            </div>
                            <div v-if="hasPoem && imageOrSymbol">
                                <div class="col">
                                    <div class="row">
                                        <div class="col-md-6 p-3">
                                            <div v-if="hasImage && previewSize > 0">
                                                <img :src="imgUrl" class="w-100">
                                            </div>
                                            <div class="text-center" v-if="hasSymbol && symbol!=null">
                                                <img :height="previewSize" :src="symbol.data" :width="previewSize">
                                            </div>
                                        </div>
                                        <div class="col-md-6 p-1 text-left poem">
                                            <span v-html="poem.text" v-if="poem"></span>
                                            <span style="white-space: pre-line" v-else>{{customPoem}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="text-center">{{beginningText}}</div>
                            <h4 class="text-center">{{name}}</h4>
                            <div class="text-center">{{endingText}}</div>
                        </div>
                    </div>
                </div>
                <single-price v-if="!adid"></single-price>
            </div>
        </div>
        <button class="btn btn-primary" type="button" v-if="adid" v-on:click.stop="saveState('save')">Salvesta õnnitlus
        </button>
        <div v-else>
            <div class="col-md-12 p-0 text-center" v-html="$t('erisoovid')"></div>
            <a @click="onContinue" class="btn btn-primary btn-block"
                v-bind:class="{disabled: !formReady || store.isLoading}">
                <MoveForwardButton />
            </a>
        </div>
    </div>
</template>

<script setup>
import MoveForwardButton from './MoveForwardButton.vue';
import { useMainStore } from '../includes/store';
import { toast } from 'vue3-toastify';
import vSelect from 'vue-select';
import MyCropper from './MyCropper.vue';
import { onMounted, ref, onDeactivated, onBeforeUnmount, computed, watch } from 'vue';

const props = defineProps({
    adid: { type: [String, Number], required: false },
    formReady: { type: Boolean, required: false }
});

const store = useMainStore();

const name = ref("");
const beginningText = ref("");
const endingText = ref("");
const hasPoem = ref(false);
const hasSymbol = ref(false);
const hasImage = ref(false);
const imageOrSymbol = ref(false);
const poems = ref([]);
const customPoem = ref("");
const poem = ref({});
const symbols = ref([]);
const symbol = ref(null);
const imageContent = ref(null);
const imgUrl = ref(null);
const originalImage = ref(null);
const saveTimeout = ref(null);
const isMounted = ref(false);
const dataContainer = ref(null);
const fileInput = ref(null);

onMounted(() => {
    loadState();
    loadPoems();
    loadSymbols();
    isMounted.value = true;
});

onDeactivated(() => {
    saveState();
});

onBeforeUnmount(() => {
    saveState();
});

const loadPoems = () => {
    axios.get('/api/poems?type=greeting').then(response => {
        poems.value = response.data;
    })
}

const loadSymbols = () => {
    axios.get('/api/symbols?type=greeting').then(response => {
        symbols.value = response.data;
    })
}

const pickSymbol = (newSymbol) => {
    hasImage.value = false;
    hasSymbol.value = true;
    symbol.value = newSymbol;
    saveState();
}

const loadState = () => {
    if (props.adid) {
        axios.get('/admin/advertisement/' + props.adid + '/data').then(response => {
            setState(response.data);
        })
    } else {
        let greeting = store.stepInfo.content.greeting;
        setState(greeting);
    }
}

const setState = (greeting) => {
    if (greeting.beginningText == null) {
        greeting.beginningText = "";
    }
    if (greeting.endingText == null) {
        greeting.endingText = "";
    }
    name.value = greeting.name;
    beginningText.value = greeting.beginningText;
    endingText.value = greeting.endingText;
    hasPoem.value = greeting.hasPoem;
    hasSymbol.value = greeting.hasSymbol;
    hasImage.value = greeting.hasImage;
    customPoem.value = greeting.customPoem;
    imageOrSymbol.value = greeting.imageOrSymbol;
    poem.value = greeting.poem;
    symbol.value = greeting.symbol;
    imgUrl.value = greeting.imgUrl;
    imageContent.value = greeting.originalImage;
    originalImage.value = greeting.originalImage;
}

const saveState = async (saveNow, disableTimeout = false) => {
    let postData = {
        name: name.value,
        beginningText: beginningText.value,
        endingText: endingText.value,
        hasPoem: hasPoem.value === true,
        hasSymbol: hasSymbol.value === true,
        hasImage: hasImage.value === true,
        imageOrSymbol: imageOrSymbol.value === true,
        customPoem: customPoem.value,
        poem: poem.value,
        symbol: symbol.value,
        imgUrl: imgUrl.value,
        originalImage: originalImage.value,
    };

    if (saveTimeout.value) {
        clearTimeout(saveTimeout.value);
    }

    if (props.adid) {
        if (saveNow === "save") {
            axios.put('/admin/advertisement/' + props.adid + '/greeting', postData).then(_ => {
                toast.info('Kuulutus salvestatud');
            }).catch(errors => {
                if (errors.response.status === 422) {
                    for (const errName in errors.response.data.errors) {
                        toast.error(errors.response.data.errors[errName][0]);
                    }
                } else {
                    toast.error('Salvestamine ebaõnnestus');
                }
            });
        } else {
            console.log('not saving data');
        }
    } else {
        store.setGreeting(postData);

        if (disableTimeout) {
            store.setIsLoading(true);
            await axios.post('/state/greeting', {
                state: postData
            }).catch(_ => {
                store.sessExpired();
            }).finally(() => {
                store.setIsLoading(false);
            });
        } else {
            saveTimeout.value = setTimeout(_ => {
                axios.post('/state/greeting', {
                    state: postData
                }).catch(_ => {
                    store.sessExpired();
                });
            }, 2500);
        }        
    }
}

const symbolChanged = (event) => {
    if (!imageOrSymbol.value) {
        hasImage.value = false;
        hasSymbol.value = false;
    }
}

const cropperCallback = (dataUrl, originalDataUrl) => {
    hasImage.value = true;
    hasSymbol.value = false;
    symbol.value = null;
    imgUrl.value = dataUrl;
    imageContent.value = originalDataUrl;
    originalImage.value = originalDataUrl;
    saveState();
}

function fileToDataURL(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onerror = () => {
      reader.abort()
      reject(new Error('Failed to read file'))
    }
    reader.onload = () => resolve(reader.result) // result is a data:... base64 string
    reader.readAsDataURL(file)
  })
}

const onFileChosen = async (event) => {
    const file = event.target.files && event.target.files[0]
    if (!file) return

    try {
        // convert to data URL (base64)
        const dataUrl = await fileToDataURL(file)
        imageContent.value = dataUrl
        event.target.value = '';
    } catch (err) {
        console.error('Could not read file as data URL', err)
    }
};
        
const previewSize = computed(() => {
    if (!isMounted.value) {
        return 2;
    }
    let previewDiv = dataContainer.value;
    let previewWidth = previewDiv.clientWidth / 2 * 0.85;

    if (!previewWidth) {
        previewWidth = 2;
    }

    return previewWidth;
})

const previewClasses = computed(() => {
    let newPreview = {
        "box-half": !(imageOrSymbol.value && hasPoem.value)
    };

    return newPreview;
})

const previewTabClasses = computed(() => {
    let newPreview = {
        "offset-md-1 col-md-5": !(imageOrSymbol.value && hasPoem.value),
        "col-md-6": imageOrSymbol.value && hasPoem.value
    };
    return newPreview;
})

const onContinue = async () => {
    await saveState(false, true);
    store.changeStep('dates');
}

watch(() => store.stateLoaded, (loaded) => {
    if (loaded) {
        loadState();
    }
}, { immediate: true });

</script>

<style scoped>
    .poem {
        font-style: italic;
    }

    .preview {
        border: solid 4px;
        border-color: #FAD643;
        border-radius: 10px;
    }
</style>
